import { Modal } from 'bootstrap';
import { Genesis } from '../GenesisExport';
const GenesisURL = require("../Genesis.js")

export class ISiteMobileAssetViewAssetDetailPage {
    private qrCode: kendo.dataviz.ui.QRCode | null = null;
    private readonly QRCodeModal = document.getElementById("modal-printQRCode");
    private readonly createSRConfirmModal = document.getElementById("modal-createSR");
    private readonly idPrintQRCode = $("#idPrintQRCode");
    private readonly idPrintContent = $("#idPrintContent");
    private readonly btnCreateSRConfirm = $("#idCreateSR");
    
    private modal: Modal | null = null;
    private modalCreateSR: Modal | null = null;

    constructor() {
        if (this.QRCodeModal !== null) {
            this.modal = new Modal(this.QRCodeModal, { backdrop: 'static', keyboard: false });
        }
        if (this.createSRConfirmModal !== null) {
            this.modalCreateSR = new Modal(this.createSRConfirmModal, { backdrop: 'static', keyboard: false });
        }
    }

    public Init() {
        var that = this;

        this.idPrintQRCode.click(function () {
            that.UpdateQRCodeText();
        });

        this.btnCreateSRConfirm.click(function () {
            var assetId = $("#RecordID").val();
            window.location.href = GenesisURL.url('/ServiceRequest/CreateSRFromAsset?assetId=' + assetId);
        });

        this.idPrintContent.click(function () {
            const divToPrint = document.getElementById('QRCodeDetail');
            const newWin = window.open('', 'Print-Window');
            newWin?.document.open();
            newWin?.document.write(
                '<body onload="window.print()">' +
                divToPrint?.innerHTML +
                '</body>'
            );
            newWin?.document.close();
        });
    }

    private UpdateQRCodeText() {
        var that = this;
        $.get(GenesisURL.url('/Asset/GetAssetUDF'), {
            RecordID: $("#RecordID").val()
        }, function (responseResult) {
            that.modal?.show();
            const qrCodeElement = document.getElementById("qrcode");
            const qrCodeText: string = $("#QRCodeLink").val() as string;
            if (responseResult != null) {
                $("#lblAgressoValue").html(responseResult.externalCodeDetail);
                $("#lblOrgRetail").html(responseResult.qrCodeLabel);
            }
            if (qrCodeElement) {
                $("#qrcode").html("");
                that.qrCode = new kendo.dataviz.ui.QRCode(qrCodeElement, {
                    value: qrCodeText,
                    size: 128,
                    color: "#000",
                    background: "#fff",
                    border: { width: 0 },
                });
            } else {
                console.error("QR Code element not found.");
            }
        });
    }
}